import { Stack, Typography } from '@mui/material';
import { pointsNextStep, pointsPreviousStep } from '../../../actions/points';
import { isEntered, setsPerMatch } from '../../../domain/matchSchedule';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import MatchRow from './MatchRow';
import StepActions from './StepActions';

export default function Step2() {
  const dispatch = useAppDispatch();
  const { usersPoints, expandedResults, editingId } = useAppSelector((s) => s.points);
  const expectedSets = setsPerMatch(usersPoints.length);
  const entered = expandedResults.filter(isEntered).length;
  const allEntered = entered === expandedResults.length && expandedResults.length > 0;

  return (
    <Stack className="step2" spacing={2}>
      <div>
        <Typography variant="h6">Wpisz wyniki</Typography>
        <Typography variant="body2" color="text.secondary">
          {entered} z {expandedResults.length} meczów · zwykle {expectedSets} setów
        </Typography>
      </div>
      {/* Every Match is editable, in any order: entering 15 results one-at-a-time behind a
          cursor was the worst part of doing this on a phone. */}
      <Stack spacing={1}>
        {expandedResults.map((match) => (
          <MatchRow key={match._id} match={match} expectedSets={expectedSets} />
        ))}
      </Stack>
      <StepActions
        {...(editingId ? {} : { onBack: () => dispatch(pointsPreviousStep()) })}
        onNext={() => dispatch(pointsNextStep())}
        nextDisabled={!allEntered}
      />
    </Stack>
  );
}
